import React, {Component} from 'react';
import {gpn} from "../GPN"
import Icon from "../sections/MUI/Icon";
import {Link} from "react-router";

class SuccessPayment extends Component {

    state = {
        ref: this.props.params.ref
    };

    componentDidMount() {
        this.props.setTitle("پرداخت موفق");
    }


    render() {
        let {ref} = this.state;
        return (
            <div className="payment success">
                <Icon i="shield-check"/>
                <div className="message">پرداخت شما موفق بوده است. با تشکر از همراهی شما</div>
                <p className="ref"><span>کد پیگیری:</span><span>{ref}</span></p>

                <div className="links">
                    <div className="row justify-content-center">
                        <Link to="/orders">لیست سفارشات</Link>
                        <Link to="/payments">لیست پرداخت ها</Link>
                    </div>
                </div>
            </div>
        );
    }
}

export default gpn(SuccessPayment);